// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3igQQ","error":"Textarea_error__3WRwL","readonly":"Textarea_readonly__33Bq1","disabled":"Textarea_disabled__1svZ6"};